<dx-pie-chart
    #pieChart
    class="dq-groups-chart"
    type="doughnut"
    [startAngle]="90"
    title="Produktkategorien"
    [resolveLabelOverlapping]="'shift'"
    [palette]="colorPalette"
    [dataSource]="dataSource">
  <dxi-series argumentField="category" valueField="productCount">
    <dxo-label [visible]="true" [customizeText]="customizeLabel">
      <dxo-connector [visible]="true"></dxo-connector>
    </dxo-label>
  </dxi-series>
  <dxo-export [enabled]="false"></dxo-export>
  <dxo-legend
      [visible]="true"
      verticalAlignment="bottom"
      horizontalAlignment="center"
      itemTextPosition="right"
      orientation="horizontal">
  </dxo-legend>
  <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeDataQualityPieTooltip"></dxo-tooltip>
</dx-pie-chart>
